try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}
import 'alpinejs';
window.overlayScrollbars = require('overlayscrollbars');
window.select2 = require('select2/dist/js/select2.js');
window.swal = require('sweetalert2');
window.DataTable = require('datatables.net');
require('datatables.net-responsive');
require('datatables.net-buttons/js/buttons.html5.min');
require('datatables.net-buttons/js/buttons.print.min');
window.JSZip = require('jszip/dist/jszip.min');
window.Highcharts = require('highcharts');
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/themes/sunset')(Highcharts);

window.toast = swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', swal.stopTimer);
        toast.addEventListener('mouseleave', swal.resumeTimer);
    }
});
import flatpickr from "flatpickr";
window.flatpickr = flatpickr;
require('./custom');
